import { ReactElement } from "react";

export default function IconProductAnalytics(): ReactElement {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z"
        fill="#DCDFE0"
        fillOpacity="0.3"
      />

      <circle
        cx="48.5"
        cy="48.5"
        r="13.5"
        stroke="#949AAB"
        strokeOpacity="0.7"
        strokeWidth="2"
      />
      <circle
        cx="48.5"
        cy="48.5"
        r="18.5"
        stroke="#949AAB"
        strokeOpacity="0.5"
        strokeWidth="2"
      />
      <circle
        cx="48.5"
        cy="48.5"
        r="24.5"
        stroke="#949AAB"
        strokeOpacity="0.3"
        strokeWidth="2"
      />
      <circle
        cx="48.5"
        cy="48.5"
        r="31.5"
        stroke="#949AAB"
        strokeOpacity="0.1"
        strokeWidth="2"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.9765 73.0642L49.0859 56.0977V82.2215C49.0859 82.9919 49.9964 83.3771 50.5567 82.8518L56.0897 77.6866L61.0973 88.5774C61.1462 88.6825 61.2154 88.7769 61.301 88.8551C61.3866 88.9332 61.4869 88.9936 61.596 89.0327C61.7052 89.0718 61.821 89.0888 61.9368 89.0828C62.0525 89.0768 62.1659 89.0478 62.2704 88.9976L65.5972 87.4743C65.7023 87.4255 65.7967 87.3562 65.8749 87.2706C65.953 87.185 66.0134 87.0847 66.0525 86.9756C66.0916 86.8664 66.1086 86.7506 66.1026 86.6349C66.0966 86.5191 66.0676 86.4057 66.0174 86.3012L61.0098 75.4279L68.5212 74.5875C68.6882 74.5666 68.8457 74.498 68.9747 74.39C69.1038 74.2819 69.1989 74.139 69.2488 73.9782C69.2987 73.8175 69.3012 73.6458 69.256 73.4837C69.2108 73.3216 69.1198 73.1759 68.994 73.0642H68.9765Z"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.5173 67.3734L49.0859 49.0938V77.2312L56.0897 70.6827L61.43 82.3614L66.3326 80.0852L60.9747 68.424L70.4998 67.3734H70.5173Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.6303 48.0955C49.0155 47.9204 49.4708 47.9904 49.8035 48.2706L71.2173 66.5327C71.386 66.6692 71.5099 66.8531 71.5731 67.0607C71.6363 67.2683 71.6358 67.49 71.5717 67.6973C71.5076 67.9046 71.3829 68.0879 71.2136 68.2237C71.0443 68.3594 70.8383 68.4413 70.622 68.4588L62.6203 69.3342L67.3478 79.6472C67.6104 80.19 67.3653 80.8378 66.8225 81.1005L61.9199 83.3592C61.6571 83.4794 61.3577 83.4918 61.0859 83.3935C60.8141 83.2953 60.5918 83.0943 60.4666 82.8339L55.7216 72.5034L49.8385 78.0363C49.6808 78.1774 49.4859 78.2701 49.277 78.3035C49.0682 78.3369 48.8541 78.3095 48.6603 78.2246C48.4666 78.1398 48.3013 78.0009 48.1842 77.8248C48.0671 77.6486 48.0032 77.4424 48 77.2309V49.0935C48 48.6733 48.2451 48.2706 48.6303 48.0955ZM50.1711 51.4572V74.7096L55.3189 69.877C55.4451 69.755 55.5991 69.6655 55.7676 69.616C55.936 69.5666 56.114 69.5587 56.2861 69.5932C56.4583 69.6276 56.6195 69.7033 56.756 69.8137C56.8925 69.9241 57.0002 70.066 57.0698 70.2272L61.9899 80.9079L64.914 79.5597L59.9939 68.879C59.9242 68.7214 59.8925 68.5497 59.9011 68.3777C59.9098 68.2056 59.9586 68.038 60.0437 67.8882C60.1289 67.7384 60.2479 67.6107 60.3912 67.5151C60.5346 67.4196 60.6983 67.359 60.8693 67.3382L67.873 66.5503L50.1887 51.4572H50.1711Z"
        fill="#949AAB"
      />

      <path d="M26.38 74V72H27.62V74H26.38Z" fill="#949AAB" />
      <path d="M26 75.63H24V74.38H26V75.63Z" fill="#949AAB" />
      <path d="M26.38 76V78H27.62V76H26.38Z" fill="#949AAB" />
      <path d="M30 75.62H28V74.37H30V75.62Z" fill="#949AAB" />

      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.38 11V13H68.63V11H67.38ZM65 14.63H67V13.37H65V14.63ZM67.38 17V15H68.63V17H67.38ZM69 14.62H71V13.38H69V14.62Z"
        fill="#949AAB"
      />
    </svg>
  );
}
